module.exports = __webpack_public_path__ + "static/media/visa-mc.21d37fd4.png";